var map = {
	"./de/blogFeeds/feeds.json": 60040,
	"./en/blogFeeds/feeds.json": 85305,
	"./es/blogFeeds/feeds.json": 50509,
	"./fr/blogFeeds/feeds.json": 54527,
	"./id/blogFeeds/feeds.json": 26453,
	"./jp/blogFeeds/feeds.json": 27713,
	"./kr/blogFeeds/feeds.json": 2465,
	"./pt/blogFeeds/feeds.json": 2569,
	"./zh/blogFeeds/feeds.json": 61072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7512;